// AddBusRoute.jsx
import React, { useState, useEffect } from 'react';
import { 
  FiMapPin, FiClock, FiDollarSign, FiPlus, FiX, FiNavigation, 
  FiArrowRight, FiCheck, FiSearch, FiHash, FiKey, FiFileText, 
  FiChevronDown, FiMap, FiGlobe, FiFlag, FiTarget,
  FiAlertCircle, FiCheckCircle
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import BaseUrl from '../../../Url/BaseUrl';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const AddBusRoute = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  const [clusterData, setClusterData] = useState({
    routeNo: '',
    routeName: '',
    status: true,
    description: '',
    fromCity: '',
    toCity: '',
    viaCities: ''
  });
  
  const [routeData, setRouteData] = useState({
    routePathNo: '',
    routePathName: '',
    hindi: '',
    routeNo: '',
    status: true,
    description: '',
    busRoute: null,
    startPointCityVillageCode: '',
    endPointCityVillageCode: ''
  });
  
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [villages, setVillages] = useState([]);
  const [selectedState, setSelectedState] = useState('');
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedVillages, setSelectedVillages] = useState([]);
  
  const [startState, setStartState] = useState('');
  const [startDistrict, setStartDistrict] = useState('');
  const [startVillages, setStartVillages] = useState([]);
  const [selectedStartVillage, setSelectedStartVillage] = useState('');
  
  const [endState, setEndState] = useState('');
  const [endDistrict, setEndDistrict] = useState('');
  const [endVillages, setEndVillages] = useState([]);
  const [selectedEndVillage, setSelectedEndVillage] = useState('');
  
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingStartDistricts, setLoadingStartDistricts] = useState(false);
  const [loadingEndDistricts, setLoadingEndDistricts] = useState(false);
  const [loadingStartVillages, setLoadingStartVillages] = useState(false);
  const [loadingEndVillages, setLoadingEndVillages] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingVillagesForDistrict, setLoadingVillagesForDistrict] = useState(false);
  
  const [createdClusterNo, setCreatedClusterNo] = useState('');
  const [createdRoutePathNo, setCreatedRoutePathNo] = useState('');

  // Status for existence checks
  const [routeNoStatus, setRouteNoStatus] = useState(null);
  const [routePathNoStatus, setRoutePathNoStatus] = useState(null);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [step]);

  useEffect(() => {
    if (step === 3) {
      fetchStates();
    }
  }, [step]);

  useEffect(() => {
    if (step === 2) {
      fetchStates();
    }
  }, [step]);

  useEffect(() => {
    if (selectedState) {
      fetchDistricts(selectedState);
    } else {
      setDistricts([]);
      setSelectedDistrict('');
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedDistrict) {
      fetchVillagesByDistrict(selectedDistrict);
    } else {
      setVillages([]);
    }
  }, [selectedDistrict]);

  useEffect(() => {
    if (startState) {
      fetchDistrictsForPoint(startState, 'start');
    } else {
      setStartDistrict('');
      setStartVillages([]);
    }
  }, [startState]);

  useEffect(() => {
    if (endState) {
      fetchDistrictsForPoint(endState, 'end');
    } else {
      setEndDistrict('');
      setEndVillages([]);
    }
  }, [endState]);

  useEffect(() => {
    if (startDistrict) {
      fetchVillagesByDistrictForPoint(startDistrict, 'start');
    } else {
      setStartVillages([]);
    }
  }, [startDistrict]);

  useEffect(() => {
    if (endDistrict) {
      fetchVillagesByDistrictForPoint(endDistrict, 'end');
    } else {
      setEndVillages([]);
    }
  }, [endDistrict]);

  useEffect(() => {
    if (selectedStartVillage) {
      setRouteData(prev => ({
        ...prev,
        startPointCityVillageCode: selectedStartVillage
      }));
    }
  }, [selectedStartVillage]);

  useEffect(() => {
    if (selectedEndVillage) {
      setRouteData(prev => ({
        ...prev,
        endPointCityVillageCode: selectedEndVillage
      }));
    }
  }, [selectedEndVillage]);

  // Check existence functions
  const checkRouteNumberExists = async (routeNo) => {
    if (!routeNo) return false;
    try {
      const response = await axios.get(`${BaseUrl.baseurl}BusRoutes/CheckIfExists?id=${routeNo}`, {
        headers: { accept: 'text/plain' }
      });
      return response.data; // true if exists
    } catch (err) {
      console.error('Check route exists failed:', err);
      return false;
    }
  };

  const checkRoutePathNumberExists = async (routePathNo) => {
    if (!routePathNo) return false;
    try {
      const response = await axios.get(`${BaseUrl.baseurl}RoutePaths/CheckIfExists?id=${routePathNo}`, {
        headers: { accept: 'text/plain' }
      });
      return response.data;
    } catch (err) {
      console.error('Check routePath exists failed:', err);
      return false;
    }
  };

  const generateCode = (startingDigit) => {
    const firstDigit = startingDigit;
    let remainingDigits = '';
    for (let i = 0; i < 7; i++) {
      remainingDigits += Math.floor(Math.random() * 10).toString();
    }
    return firstDigit + remainingDigits;
  };

  const validateCode = (code, startingDigit, type) => {
    if (!code) {
      toast.error(`Please enter a ${type} Number to validate`);
      return false;
    }
    const hasAlphabets = /[a-zA-Z]/.test(code);
    const hasSpecialChars = /[!@#$%^&*(),.?":{}|<>]/.test(code);
    const hasSpaces = /\s/.test(code);
    
    if (hasAlphabets || hasSpecialChars || hasSpaces) {
      toast.error(`${type} Number should contain only numeric digits (0-9)`);
      return false;
    }
    if (code.length !== 8) {
      toast.error(`${type} Number should be exactly 8 digits`);
      return false;
    }
    if (code[0] !== startingDigit) {
      toast.error(`${type} Number must start with digit ${startingDigit}`);
      return false;
    }
    if (!/^\d+$/.test(code)) {
      toast.error(`${type} Number should contain only numeric digits`);
      return false;
    }
    return true;
  };

  // Generate ONLY a random number, do NOT check availability
  const generateClusterNo = () => {
    const newNumber = generateCode('1');
    setClusterData(prev => ({ ...prev, routeNo: newNumber }));
    setRouteNoStatus(null); // Clear previous status – must validate
  };

  const generateRouteNo = () => {
    const newNumber = generateCode('2');
    setRouteData(prev => ({ ...prev, routePathNo: newNumber }));
    setRoutePathNoStatus(null);
  };

  // Validate route number: check format + existence
  const validateClusterNo = async () => {
    const isValid = validateCode(clusterData.routeNo, '1', 'Route');
    if (!isValid) {
      setRouteNoStatus(null);
      return;
    }
    const exists = await checkRouteNumberExists(clusterData.routeNo);
    if (exists) {
      setRouteNoStatus('taken');
      toast.error(`Route Number ${clusterData.routeNo} already exists.`);
    } else {
      setRouteNoStatus('available');
      toast.success(`✓ Valid and available Route Number: ${clusterData.routeNo}`,{ style: {
        background: '#ffffff',
        color: '#1f2937',
        border: '1px solid #e5e7eb'
      }});
    }
  };

  // Validate routePath number: check format + existence
  const validateRouteNo = async () => {
    const isValid = validateCode(routeData.routePathNo, '2', 'RoutePath');
    if (!isValid) {
      setRoutePathNoStatus(null);
      return;
    }
    const exists = await checkRoutePathNumberExists(routeData.routePathNo);
    if (exists) {
      setRoutePathNoStatus('taken');
      toast.error(`RoutePath Number ${routeData.routePathNo} already exists.`);
    } else {
      setRoutePathNoStatus('available');
      toast.success(`✓ Valid and available RoutePath Number: ${routeData.routePathNo}`,{ style: {
        background: '#ffffff',
        color: '#1f2937',
        border: '1px solid #e5e7eb'
      }});
    }
  };

  // ========== DATA FETCHING (only villages filtered by status) ==========
  const fetchStates = async () => {
    setLoadingStates(true);
    try {
      const response = await axios.get(BaseUrl.baseurl + 'States');
      if (response.data && Array.isArray(response.data)) {
        // Show all states (no status filter)
        setStates(response.data);
      }
    } catch (err) {
      console.error('Failed to fetch states:', err);
      toast.error('Could not load states. Please refresh.');
    } finally {
      setLoadingStates(false);
    }
  };

  const fetchDistricts = async (stateCode) => {
    setLoadingDistricts(true);
    try {
      const response = await axios.get(`${BaseUrl.baseurl}Districts/GetDistrictsByStateId?StateCode=${stateCode}`);
      if (response.data && Array.isArray(response.data)) {
        // Show all districts (no status filter)
        setDistricts(response.data);
      }
    } catch (err) {
      console.error('Failed to fetch districts:', err);
      toast.error('Could not load districts. Please try again.');
    } finally {
      setLoadingDistricts(false);
    }
  };

  const fetchDistrictsForPoint = async (stateCode, type) => {
    if (type === 'start') {
      setLoadingStartDistricts(true);
    } else {
      setLoadingEndDistricts(true);
    }
    
    try {
      const response = await axios.get(`${BaseUrl.baseurl}Districts/GetDistrictsByStateId?StateCode=${stateCode}`);
      if (response.data && Array.isArray(response.data)) {
        // Show all districts (no status filter)
        if (type === 'start') {
          setStartVillages([]);
          setStartDistrict('');
          window.startDistricts = response.data;
        } else {
          setEndVillages([]);
          setEndDistrict('');
          window.endDistricts = response.data;
        }
      }
    } catch (err) {
      console.error('Failed to fetch districts:', err);
      toast.error('Could not load districts. Please try again.');
    } finally {
      if (type === 'start') {
        setLoadingStartDistricts(false);
      } else {
        setLoadingEndDistricts(false);
      }
    }
  };

  const fetchVillagesByDistrict = async (districtCode) => {
    setLoadingVillagesForDistrict(true);
    try {
      const response = await axios.get(`${BaseUrl.baseurl}CityVillages/GetCityVillagesByDistrictCode?DistrictCode=${districtCode}`);
      if (response.data && Array.isArray(response.data)) {
        // ✅ Only active villages (status === true)
        const activeVillages = response.data.filter(village => village.status === true);
        // ✅ Sort alphabetically by village name (A–Z)
        const sortedVillages = [...activeVillages].sort((a, b) =>
          (a.cityVillageName || '').localeCompare(b.cityVillageName || '', undefined, { sensitivity: 'base' })
        );
        setVillages(sortedVillages);
      }
    } catch (err) {
      console.error('Failed to fetch villages:', err);
      toast.error('Could not load villages. Please try again.');
    } finally {
      setLoadingVillagesForDistrict(false);
    }
  };

  const fetchVillagesByDistrictForPoint = async (districtCode, type) => {
    if (type === 'start') {
      setLoadingStartVillages(true);
    } else {
      setLoadingEndVillages(true);
    }
    
    try {
      const response = await axios.get(`${BaseUrl.baseurl}CityVillages/GetCityVillagesByDistrictCode?DistrictCode=${districtCode}`);
      if (response.data && Array.isArray(response.data)) {
        // ✅ Only active villages
        const activeVillages = response.data.filter(village => village.status === true);
        // ✅ Sort alphabetically by village name (A–Z)
        const sortedVillages = [...activeVillages].sort((a, b) =>
          (a.cityVillageName || '').localeCompare(b.cityVillageName || '', undefined, { sensitivity: 'base' })
        );
        if (type === 'start') {
          setStartVillages(sortedVillages);
        } else {
          setEndVillages(sortedVillages);
        }
      }
    } catch (err) {
      console.error('Failed to fetch villages:', err);
      toast.error('Could not load villages. Please try again.');
    } finally {
      if (type === 'start') {
        setLoadingStartVillages(false);
      } else {
        setLoadingEndVillages(false);
      }
    }
  };

  const handleClusterChange = (e) => {
    const { name, value, type, checked } = e.target;
    setClusterData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    if (name === 'routeNo') {
      setRouteNoStatus(null); // Clear status when user edits
    }
  };

  const handleRouteChange = (e) => {
    const { name, value, type, checked } = e.target;
    setRouteData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
      routeNo: createdClusterNo
    }));
    if (name === 'routePathNo') {
      setRoutePathNoStatus(null); // Clear status when user edits
    }
  };

  const handleVillageCheck = (village, checked) => {
    if (checked) {
      if (!selectedVillages.some(v => v.cityVillageCode === village.cityVillageCode)) {
        setSelectedVillages([
          ...selectedVillages,
          {
            cityVillageCode: village.cityVillageCode,
            cityVillageName: village.cityVillageName,
            description: ''
          }
        ]);
      }
    } else {
      setSelectedVillages(selectedVillages.filter(v => v.cityVillageCode !== village.cityVillageCode));
    }
  };

  const updateVillageDescription = (code, newDesc) => {
    setSelectedVillages(selectedVillages.map(v =>
      v.cityVillageCode === code ? { ...v, description: newDesc } : v
    ));
  };

  const removeSelectedVillage = (code) => {
    setSelectedVillages(selectedVillages.filter(v => v.cityVillageCode !== code));
  };

  const handleCreateCluster = async (e) => {
    e.preventDefault();
    
    if (routeNoStatus !== 'available') {
      toast.error('Please validate the Route Number and ensure it is available.');
      return;
    }
    
    setIsLoading(true);
    setError(null);
    
    let routeName = '';
    if (clusterData.fromCity && clusterData.toCity) {
      routeName = `${clusterData.fromCity} to ${clusterData.toCity}`;
      if (clusterData.viaCities) {
        routeName += ` via ${clusterData.viaCities}`;
      }
    }
    
    const payload = {
      routeNo: clusterData.routeNo,
      routeName: routeName || clusterData.routeName,
      status: clusterData.status,
      description: clusterData.description
    };

    console.log('📤 Step 1 - Creating Route, payload:', payload);

    try {
      const response = await axios.post(BaseUrl.baseurl + 'BusRoutes', payload);
      console.log('✅ Step 1 - Route created, response:', response.data);
      
      if (response.data) {
        setCreatedClusterNo(clusterData.routeNo);
        setRouteData(prev => ({ 
          ...prev, 
          routeNo: clusterData.routeNo
        }));
        setStep(2);
        toast.success('Route created successfully!',{ style: {
          background: '#ffffff',
          color: '#1f2937',
          border: '1px solid #e5e7eb'
        }});
      }
    } catch (err) {
      console.error('❌ Step 1 - Failed to create route:', err);
      toast.error(err.response?.data?.message || 'Failed to create route');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateRoute = async (e) => {
    e.preventDefault();
    
    if (routePathNoStatus !== 'available') {
      toast.error('Please validate the RoutePath Number and ensure it is available.');
      setIsLoading(false);
      return;
    }
    
    setIsLoading(true);
    setError(null);
    
    if (!routeData.startPointCityVillageCode) {
      toast.error('Please select a start point village');
      setIsLoading(false);
      return;
    }
    if (!routeData.endPointCityVillageCode) {
      toast.error('Please select an end point village');
      setIsLoading(false);
      return;
    }
    if (!routeData.routePathName.trim()) {
      toast.error('Please enter RoutePath Name');
      setIsLoading(false);
      return;
    }
    
    const payload = {
      routePathNo: routeData.routePathNo,
      routePathName: routeData.routePathName,
      hindi: routeData.hindi || '',
      routeNo: createdClusterNo,
      status: routeData.status,
      description: routeData.description || '',
      startPointCityVillageCode: routeData.startPointCityVillageCode,
      endPointCityVillageCode: routeData.endPointCityVillageCode
    };

    console.log('📤 Step 2 - Creating RoutePath with start/end points, payload:', payload);

    try {
      const response = await axios.post(BaseUrl.baseurl + 'RoutePaths', payload);
      console.log('✅ Step 2 - RoutePath created, response:', response.data);
      
      if (response.data) {
        setCreatedRoutePathNo(routeData.routePathNo);
        setStep(3);
        toast.success('RoutePath created successfully!',{ style: {
          background: '#ffffff',
          color: '#1f2937',
          border: '1px solid #e5e7eb'
        }});
      }
    } catch (err) {
      console.error('❌ Step 2 - Failed to create routePath:', err);
      toast.error(err.response?.data?.message || 'Failed to create routePath');
    } finally {
      setIsLoading(false);
    }
  };

  const handleCreateStoppageList = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    if (selectedVillages.length === 0) {
      toast.error('Please select at least one village.');
      setIsLoading(false);
      return;
    }

    const payloadArray = selectedVillages.map(v => ({
      routePathNo: createdRoutePathNo,
      cityVillageCode: v.cityVillageCode,
      status: true,
      description: v.description || null
    }));

    console.log('📤 Step 3 - Creating RoutePathVillages, payload:', payloadArray);

    try {
      const response = await axios.post(BaseUrl.baseurl + 'RoutePathVillages', payloadArray);
      console.log('✅ Step 3 - RoutePathVillages created, response:', response.data);
      toast.success('RoutePathVillages created successfully!',{ style: {
        background: '#ffffff',
        color: '#1f2937',
        border: '1px solid #e5e7eb'
      }});
      setTimeout(() => {
        navigate('/route-finder-panel');
      }, 2000);
    } catch (err) {
      console.error('❌ Step 3 - Failed to create routePathVillages:', err);
      if (err.response) {
        console.error('Error response data:', err.response.data);
        console.error('Error response status:', err.response.status);
      }
      toast.error(err.response?.data?.message || 'Failed to create routePathVillages');
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {
    setClusterData({
      routeNo: '',
      routeName: '',
      status: true,
      description: '',
      fromCity: '',
      toCity: '',
      viaCities: ''
    });
    setRouteData({
      routePathNo: '',
      routePathName: '',
      hindi: '',
      routeNo: '',
      status: true,
      description: '',
      startPointCityVillageCode: '',
      endPointCityVillageCode: ''
    });
    setSelectedVillages([]);
    setCreatedClusterNo('');
    setCreatedRoutePathNo('');
    setStep(1);
    setError(null);
    setSuccess(null);
    setSelectedState('');
    setSelectedDistrict('');
    setStartState('');
    setStartDistrict('');
    setSelectedStartVillage('');
    setEndState('');
    setEndDistrict('');
    setSelectedEndVillage('');
    setRouteNoStatus(null);
    setRoutePathNoStatus(null);
  };

  return (
    <div className="add-route-container">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />

      <style>{`
        /* ===== Global / Container ===== */
        .add-route-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .form-header {
          margin-bottom: 24px;
        }

      
        .btn-back:hover {
          text-decoration: underline;
        }

        .progress-steps {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 32px;
        }

        .step {
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
        }

        .step-number {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-color: #e2e8f0;
          color: #718096;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          margin-bottom: 6px;
          transition: all 0.3s;
        }

        .step.active .step-number {
          background-color: #4a6cf7;
          color: white;
        }

        .step-label {
          font-size: 0.9rem;
          color: #718096;
          font-weight: 500;
        }

        .step.active .step-label {
          color: #2d3748;
        }

        .step-connector {
          width: 80px;
          height: 2px;
          background-color: #e2e8f0;
          margin: 0 8px;
          transition: background-color 0.3s;
        }

        .step-connector.active {
          background-color: #4a6cf7;
        }

        .route-form {
          background: white;
          border-radius: 16px;
          box-shadow: 0 8px 30px rgba(0, 0, 0, 0.05);
          padding: 32px;
        }

        .form-section {
          margin-bottom: 32px;
        }

        .section-title {
          font-size: 1.5rem;
          font-weight: 600;
          color: #1e293b;
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 24px;
          border-bottom: 2px solid #eef2f6;
          padding-bottom: 12px;
        }

        .section-icon {
          color: #4a6cf7;
          font-size: 1.8rem;
        }

        .step-info {
          background: #f8fafd;
          padding: 8px 16px;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 0.95rem;
          color: #475569;
          border-left: 4px solid #4a6cf7;
        }

        .step-info strong {
          color: #1e293b;
        }

        .input-group {
          margin-bottom: 20px;
        }

        .input-group label {
          display: block;
          font-weight: 500;
          margin-bottom: 8px;
          color: #334155;
          font-size: 0.95rem;
        }

        .input-group input,
        .input-group select,
        .input-group textarea {
          width: 100%;
          padding: 12px 16px;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          font-size: 1rem;
          transition: all 0.2s;
          background: white;
        }

        .input-group input:focus,
        .input-group select:focus,
        .input-group textarea:focus {
          outline: none;
          border-color: #4a6cf7;
          box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
        }

        .input-group input.disabled-input,
        .input-group input:disabled {
          background: #f1f5f9;
          color: #64748b;
          border-color: #cbd5e1;
          cursor: not-allowed;
        }

        textarea {
          resize: vertical;
          min-height: 80px;
        }

        .code-input-group {
          margin-bottom: 8px;
        }

        .input-with-buttons {
          display: flex;
          gap: 12px;
          align-items: center;
          flex-wrap: wrap;
        }

        .input-with-buttons input {
          flex: 1;
          min-width: 200px;
        }

        .code-buttons {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
        }

        .btn-generate,
        .btn-validate {
          padding: 10px 16px;
          border: none;
          border-radius: 8px;
          font-weight: 500;
          font-size: 0.9rem;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s;
        }

        .btn-generate {
          background: #eef2ff;
          color: #4a6cf7;
          border: 1px solid #c7d2fe;
        }

        .btn-generate:hover:not(:disabled) {
          background: #e0e7ff;
        }

        .btn-validate {
          background: #ecfdf3;
          color: #0e7b32;
          border: 1px solid #abefc6;
        }

        .btn-validate:hover:not(:disabled) {
          background: #d1fae5;
        }

        .btn-generate:disabled,
        .btn-validate:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .input-hint {
          font-size: 0.85rem;
          color: #64748b;
          margin-top: 6px;
        }

        .status-message {
          display: flex;
          align-items: center;
          gap: 0.375rem;
          font-size: 0.85rem;
          padding: 0.25rem 0;
        }
        .status-message.success {
          color: #10b981;
        }
        .status-message.error {
          color: #dc2626;
        }

        .start-end-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
          margin-top: 24px;
          margin-bottom: 24px;
        }

        .point-card {
          background: #f8fafd;
          border-radius: 16px;
          padding: 20px;
          border: 1px solid #e2e8f0;
        }

        .point-card h4 {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #1e293b;
          margin-top: 0;
          margin-bottom: 16px;
          font-size: 1.1rem;
        }

        .point-card.start h4 {
          color: #059669;
        }

        .point-card.end h4 {
          color: #dc2626;
        }

        .point-icon {
          font-size: 1.2rem;
        }

        .selected-village-badge {
          margin-top: 12px;
          padding: 12px;
          background: white;
          border-radius: 8px;
          border-left: 4px solid #4a6cf7;
        }

        .selected-village-badge.start {
          border-left-color: #059669;
        }

        .selected-village-badge.end {
          border-left-color: #dc2626;
        }

        .selected-village-badge p {
          margin: 0;
          font-size: 0.9rem;
        }

        .selected-village-badge strong {
          color: #1e293b;
        }

        .hindi-input {
          margin-top: 20px;
          padding: 16px;
          background: #f0f9ff;
          border-radius: 12px;
          border: 1px solid #bae6fd;
        }

        .hindi-input label {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #0369a1;
          font-weight: 500;
        }

        .village-selection-layout {
          display: flex;
          gap: 24px;
          margin-top: 20px;
          flex-wrap: wrap;
        }

        .card {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04);
          padding: 24px;
          transition: box-shadow 0.2s ease;
          border: 1px solid #edf2f7;
        }

        .card:hover {
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
        }

        .selection-panel {
          flex: 2;
          min-width: 300px;
        }

        .selection-panel h4,
        .preview-panel h4 {
          margin-top: 0;
          margin-bottom: 20px;
          font-size: 1.2rem;
          font-weight: 600;
          color: #1e293b;
          display: flex;
          align-items: center;
          gap: 8px;
          border-bottom: 1px solid #eef2f6;
          padding-bottom: 12px;
        }

        .selection-panel h4 .icon {
          color: #4a6cf7;
        }

        .row-fields {
          display: flex;
          gap: 16px;
          margin-bottom: 20px;
          flex-wrap: wrap;
        }

        .row-fields .input-group.half {
          flex: 1 1 calc(50% - 8px);
          min-width: 200px;
        }

        .row-fields .input-group {
          margin-bottom: 0;
        }

        .village-checkbox-group {
          margin-top: 8px;
        }

        .village-checkbox-group > label {
          font-weight: 600;
          margin-bottom: 12px;
          display: block;
          color: #334155;
        }

        .checkbox-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 10px;
          max-height: 350px;
          overflow-y: auto;
          padding: 8px 4px;
          border: 1px solid #e9eef3;
          border-radius: 12px;
          background: #fafcff;
        }

        .checkbox-item {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          background: white;
          border-radius: 8px;
          cursor: pointer;
          transition: background 0.2s, border-color 0.2s;
          font-size: 0.95rem;
          border: 1px solid transparent;
        }

        .checkbox-item:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
        }

        .checkbox-item input[type="checkbox"] {
          width: 18px;
          height: 18px;
          cursor: pointer;
          accent-color: #4a6cf7;
        }

        .checkbox-item .village-name {
          font-weight: 500;
          color: #1e293b;
          flex: 1;
        }

        .checkbox-item .village-code {
          color: #64748b;
          font-size: 0.8rem;
        }

        .loading-text,
        .empty-text,
        .no-selection {
          color: #64748b;
          font-style: italic;
          padding: 16px;
          background: #f8fafc;
          border-radius: 10px;
          text-align: center;
          border: 1px dashed #cbd5e1;
        }

        .loader-small {
          font-size: 0.85rem;
          color: #4a6cf7;
          margin-left: 8px;
        }

        .preview-panel {
          flex: 1;
          min-width: 280px;
          background: #f9fcff;
          border: 1px solid #e2e8f0;
        }

        .selected-list {
          max-height: 450px;
          overflow-y: auto;
          padding-right: 4px;
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .selected-item {
          background: white;
          border-radius: 12px;
          padding: 14px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
          border: 1px solid #eef2f6;
          transition: all 0.2s;
        }

        .selected-item:hover {
          border-color: #cbd5e1;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.04);
        }

        .selected-item-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        .selected-village-name {
          font-weight: 600;
          color: #1e293b;
          font-size: 1rem;
        }

        .btn-remove-item {
          background: none;
          border: none;
          color: #94a3b8;
          cursor: pointer;
          display: flex;
          align-items: center;
          padding: 6px;
          border-radius: 30px;
          transition: all 0.2s;
        }

        .btn-remove-item:hover {
          color: #ef4444;
          background: #fee2e2;
        }

        .selected-item-desc input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 0.9rem;
          transition: border 0.2s;
        }

        .selected-item-desc input:focus {
          outline: none;
          border-color: #4a6cf7;
          box-shadow: 0 0 0 3px rgba(74, 108, 247, 0.1);
        }

        .form-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 32px;
          border-top: 2px solid #eef2f6;
          padding-top: 24px;
        }

        .btn-secondary,
        .btn-primary {
          padding: 12px 28px;
          border: none;
          border-radius: 30px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.2s;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .btn-secondary {
          background: white;
          color: #334155;
          border: 1px solid #cbd5e1;
        }

        .btn-secondary:hover:not(:disabled) {
          background: #f1f5f9;
          border-color: #94a3b8;
        }

        .btn-primary {
          background: #4a6cf7;
          color: white;
          border: 1px solid #3b5bdb;
        }

        .btn-primary:hover:not(:disabled) {
          background: #3b5bdb;
          transform: translateY(-1px);
          box-shadow: 0 6px 14px rgba(74, 108, 247, 0.25);
        }

        .btn-primary:disabled,
        .btn-secondary:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        /* style for input when validation succeeded */
        .input-group input.success {
          border-color: #10b981;
          background-color: #f0fdf4;
        }
        .input-group input.error {
          border-color: #dc2626;
          background-color: #fef2f2;
        }

        @media (max-width: 768px) {
          .route-form {
            padding: 20px;
          }
          .progress-steps {
            flex-wrap: wrap;
          }
          .step-connector {
            width: 30px;
          }
          .start-end-section {
            grid-template-columns: 1fr;
          }
          .village-selection-layout {
            flex-direction: column;
          }
          .row-fields .input-group.half {
            flex: 1 1 100%;
          }
          .checkbox-grid {
            grid-template-columns: 1fr;
          }
          .form-actions {
            flex-direction: column;
            gap: 12px;
          }
          .btn-secondary,
          .btn-primary {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>

      <div className="form-header">
        <button className="btn-back" onClick={() => navigate('/route-finder-panel')}>
          ← Back
        </button>
      </div>

      <div className="progress-steps">
        <div className={`step ${step >= 1 ? 'active' : ''}`}>
          <span className="step-number">1</span>
          <span className="step-label">Route</span>
        </div>
        <div className={`step-connector ${step >= 2 ? 'active' : ''}`}></div>
        <div className={`step ${step >= 2 ? 'active' : ''}`}>
          <span className="step-number">2</span>
          <span className="step-label">RoutePath</span>
        </div>
        <div className={`step-connector ${step >= 3 ? 'active' : ''}`}></div>
        <div className={`step ${step >= 3 ? 'active' : ''}`}>
          <span className="step-number">3</span>
          <span className="step-label">RoutePathVillages</span>
        </div>
      </div>

      {step === 1 && (
        <form onSubmit={handleCreateCluster} className="route-form">
          <div className="form-section">
            <h3 className="section-title">
              <FiNavigation className="section-icon" />
              Step 1: Route Information
            </h3>
            
            <div className="input-group">
              <label>Route Number * (8 digits starting with 1)</label>
              <div className="code-input-group">
                <div className="input-with-buttons">
                  <input
                    type="text"
                    name="routeNo"
                    value={clusterData.routeNo}
                    onChange={handleClusterChange}
                    placeholder="e.g., 10000000"
                    required
                    disabled={isLoading}
                    maxLength="8"
                    className={routeNoStatus === 'taken' ? 'error' : routeNoStatus === 'available' ? 'success' : ''}
                  />
                  <div className="code-buttons">
                    <button
                      type="button"
                      className="btn-generate"
                      onClick={generateClusterNo}
                      disabled={isLoading}
                      title="Generate 8-digit numeric code starting with 1"
                    >
                      <FiHash /> Generate
                    </button>
                    <button
                      type="button"
                      className="btn-validate"
                      onClick={validateClusterNo}
                      disabled={isLoading || !clusterData.routeNo.trim()}
                      title="Validate route number format and availability"
                    >
                      <FiKey /> Validate
                    </button>
                  </div>
                </div>
                <div className="input-hint">
                  Must be 8 numeric digits starting with 1 (e.g., 1XXXXXXX)
                </div>
                {routeNoStatus === 'available' && (
                  <div className="status-message success">
                    <FiCheckCircle /> Route Number is available!
                  </div>
                )}
                {routeNoStatus === 'taken' && (
                  <div className="status-message error">
                    <FiAlertCircle /> Route Number already exists!
                  </div>
                )}
              </div>
            </div>

            <div className="naming-section">
              <div className="input-group">
                <label>Route Name *</label>
                <input
                  type="text"
                  name="routeName"
                  value={clusterData.routeName}
                  onChange={handleClusterChange}
                  placeholder="e.g., Mumbai to Delhi via Nagpur"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="input-group">
              <label>Description</label>
              <textarea
                name="description"
                value={clusterData.description}
                onChange={handleClusterChange}
                placeholder="Describe this route..."
                rows="3"
                disabled={isLoading}
              />
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={handleReset}
              disabled={isLoading}
            >
              Reset All
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isLoading || routeNoStatus !== 'available'}
            >
              {isLoading ? 'Creating...' : 'Create Route →'}
            </button>
          </div>
        </form>
      )}

      {step === 2 && (
        <form onSubmit={handleCreateRoute} className="route-form">
          <div className="form-section">
            <h3 className="section-title">
              <FiMapPin className="section-icon" />
              Step 2: RoutePath Information
            </h3>
            <p className="step-info">For Route: <strong>{createdClusterNo}</strong></p>
            
            <div className="input-group">
              <label>RoutePath Number * (8 digits starting with 2)</label>
              <div className="code-input-group">
                <div className="input-with-buttons">
                  <input
                    type="text"
                    name="routePathNo"
                    value={routeData.routePathNo}
                    onChange={handleRouteChange}
                    placeholder="e.g., 20000000"
                    required
                    disabled={isLoading}
                    maxLength="8"
                    className={routePathNoStatus === 'taken' ? 'error' : routePathNoStatus === 'available' ? 'success' : ''}
                  />
                  <div className="code-buttons">
                    <button
                      type="button"
                      className="btn-generate"
                      onClick={generateRouteNo}
                      disabled={isLoading}
                      title="Generate 8-digit numeric code starting with 2"
                    >
                      <FiHash /> Generate
                    </button>
                    <button
                      type="button"
                      className="btn-validate"
                      onClick={validateRouteNo}
                      disabled={isLoading || !routeData.routePathNo.trim()}
                      title="Validate routePath number format and availability"
                    >
                      <FiKey /> Validate
                    </button>
                  </div>
                </div>
                <div className="input-hint">
                  Must be 8 numeric digits starting with 2 (e.g., 2XXXXXXX)
                </div>
                {routePathNoStatus === 'available' && (
                  <div className="status-message success">
                    <FiCheckCircle /> RoutePath Number is available!
                  </div>
                )}
                {routePathNoStatus === 'taken' && (
                  <div className="status-message error">
                    <FiAlertCircle /> RoutePath Number already exists!
                  </div>
                )}
              </div>
            </div>

            <div className="naming-section">
              <div className="input-group">
                <label>RoutePath Name *</label>
                <input
                  type="text"
                  name="routePathName"
                  value={routeData.routePathName}
                  onChange={handleRouteChange}
                  placeholder="e.g., Mumbai to Delhi Express"
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="hindi-input">
              <div className="input-group">
                <label>
                  <FiGlobe /> Hindi Name (Optional)
                </label>
                <input
                  type="text"
                  name="hindi"
                  value={routeData.hindi}
                  onChange={handleRouteChange}
                  placeholder="मार्ग का नाम हिंदी में (e.g., मुंबई से दिल्ली मार्ग)"
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="start-end-section">
              <div className="point-card start">
                <h4>
                  <FiFlag className="point-icon" /> Start Point *
                </h4>
                
                <div className="input-group">
                  <label>State</label>
                  <select
                    value={startState}
                    onChange={(e) => setStartState(e.target.value)}
                    disabled={loadingStates || isLoading}
                  >
                    <option value="">-- Select State --</option>
                    {states.map(state => (
                      <option key={state.stateCode} value={state.stateCode}>
                        {state.stateName}
                      </option>
                    ))}
                  </select>
                  {loadingStates && <span className="loader-small">Loading...</span>}
                </div>

                <div className="input-group">
                  <label>District</label>
                  <select
                    value={startDistrict}
                    onChange={(e) => setStartDistrict(e.target.value)}
                    disabled={loadingStartDistricts || isLoading || !startState}
                  >
                    <option value="">-- Select District --</option>
                    {window.startDistricts?.map(district => (
                      <option key={district.districtCode} value={district.districtCode}>
                        {district.districtName}
                      </option>
                    ))}
                  </select>
                  {loadingStartDistricts && <span className="loader-small">Loading...</span>}
                </div>

                <div className="input-group">
                  <label>Village/City</label>
                  <select
                    value={selectedStartVillage}
                    onChange={(e) => setSelectedStartVillage(e.target.value)}
                    disabled={loadingStartVillages || isLoading || !startDistrict}
                  >
                    <option value="">-- Select Village --</option>
                    {startVillages.map(village => (
                      <option key={village.cityVillageCode} value={village.cityVillageCode}>
                        {village.cityVillageName} ({village.cityVillageCode})
                      </option>
                    ))}
                  </select>
                  {loadingStartVillages && <span className="loader-small">Loading...</span>}
                </div>

                {selectedStartVillage && (
                  <div className="selected-village-badge start">
                    <p><strong>Start Point Selected:</strong> {
                      startVillages.find(v => v.cityVillageCode === selectedStartVillage)?.cityVillageName
                    }</p>
                  </div>
                )}
              </div>

              <div className="point-card end">
                <h4>
                  <FiTarget className="point-icon" /> End Point *
                </h4>
                
                <div className="input-group">
                  <label>State</label>
                  <select
                    value={endState}
                    onChange={(e) => setEndState(e.target.value)}
                    disabled={loadingStates || isLoading}
                  >
                    <option value="">-- Select State --</option>
                    {states.map(state => (
                      <option key={state.stateCode} value={state.stateCode}>
                        {state.stateName}
                      </option>
                    ))}
                  </select>
                  {loadingStates && <span className="loader-small">Loading...</span>}
                </div>

                <div className="input-group">
                  <label>District</label>
                  <select
                    value={endDistrict}
                    onChange={(e) => setEndDistrict(e.target.value)}
                    disabled={loadingEndDistricts || isLoading || !endState}
                  >
                    <option value="">-- Select District --</option>
                    {window.endDistricts?.map(district => (
                      <option key={district.districtCode} value={district.districtCode}>
                        {district.districtName}
                      </option>
                    ))}
                  </select>
                  {loadingEndDistricts && <span className="loader-small">Loading...</span>}
                </div>

                <div className="input-group">
                  <label>Village/City</label>
                  <select
                    value={selectedEndVillage}
                    onChange={(e) => setSelectedEndVillage(e.target.value)}
                    disabled={loadingEndVillages || isLoading || !endDistrict}
                  >
                    <option value="">-- Select Village --</option>
                    {endVillages.map(village => (
                      <option key={village.cityVillageCode} value={village.cityVillageCode}>
                        {village.cityVillageName} ({village.cityVillageCode})
                      </option>
                    ))}
                  </select>
                  {loadingEndVillages && <span className="loader-small">Loading...</span>}
                </div>

                {selectedEndVillage && (
                  <div className="selected-village-badge end">
                    <p><strong>End Point Selected:</strong> {
                      endVillages.find(v => v.cityVillageCode === selectedEndVillage)?.cityVillageName
                    }</p>
                  </div>
                )}
              </div>
            </div>

            <div className="input-group">
              <label>
                <FiFileText className="input-icon" /> Description (Optional)
              </label>
              <textarea
                name="description"
                value={routeData.description}
                onChange={handleRouteChange}
                placeholder="Describe this routePath, e.g., Expressway route, scenic route, etc."
                rows="3"
                disabled={isLoading}
              />
            </div>

            <div className="input-group">
              <label>Route Number</label>
              <input
                type="text"
                value={createdClusterNo}
                disabled
                className="disabled-input"
              />
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => setStep(1)}
              disabled={isLoading}
            >
              ← Back
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isLoading || !selectedStartVillage || !selectedEndVillage || routePathNoStatus !== 'available'}
            >
              {isLoading ? 'Creating...' : 'Create RoutePath →'}
            </button>
          </div>
        </form>
      )}

      {step === 3 && (
        <form onSubmit={handleCreateStoppageList} className="route-form">
          <div className="form-section">
            <div className="section-header">
              <h3 className="section-title">
                <FiGlobe className="section-icon" />
                Step 3: Select Villages
              </h3>
              <p className="step-info">For RoutePath: <strong>{createdRoutePathNo}</strong></p>
            </div>

            <div className="village-selection-layout">
              <div className="selection-panel card">
                <h4>
                  <FiMap className="icon" /> Choose Villages
                </h4>

                <div className="row-fields">
                  <div className="input-group half">
                    <label>State *</label>
                    <select
                      value={selectedState}
                      onChange={(e) => setSelectedState(e.target.value)}
                      disabled={loadingStates || isLoading}
                    >
                      <option value="">-- Select State --</option>
                      {states.map(state => (
                        <option key={state.stateCode} value={state.stateCode}>
                          {state.stateName}
                        </option>
                      ))}
                    </select>
                    {loadingStates && <span className="loader-small">Loading...</span>}
                  </div>

                  <div className="input-group half">
                    <label>District *</label>
                    <select
                      value={selectedDistrict}
                      onChange={(e) => setSelectedDistrict(e.target.value)}
                      disabled={loadingDistricts || isLoading || !selectedState}
                    >
                      <option value="">-- Select District --</option>
                      {districts.map(district => (
                        <option key={district.districtCode} value={district.districtCode}>
                          {district.districtName}
                        </option>
                      ))}
                    </select>
                    {loadingDistricts && <span className="loader-small">Loading...</span>}
                  </div>
                </div>

                {selectedDistrict && (
                  <div className="village-checkbox-group">
                    <label>Villages</label>
                    {loadingVillagesForDistrict ? (
                      <p className="loading-text">Loading villages...</p>
                    ) : villages.length === 0 ? (
                      <p className="empty-text">No villages found for this district.</p>
                    ) : (
                      <div className="checkbox-grid">
                        {villages.map(village => (
                          <label key={village.cityVillageCode} className="checkbox-item">
                            <input
                              type="checkbox"
                              checked={selectedVillages.some(v => v.cityVillageCode === village.cityVillageCode)}
                              onChange={(e) => handleVillageCheck(village, e.target.checked)}
                              disabled={isLoading}
                            />
                            <span className="village-name">{village.cityVillageName}</span>
                            <span className="village-code">({village.cityVillageCode})</span>
                          </label>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="preview-panel card">
                <h4>Selected Villages ({selectedVillages.length})</h4>
                {selectedVillages.length === 0 ? (
                  <p className="no-selection">No villages selected yet.</p>
                ) : (
                  <div className="selected-list">
                    {selectedVillages.map(v => (
                      <div key={v.cityVillageCode} className="selected-item">
                        <div className="selected-item-header">
                          <span className="selected-village-name">{v.cityVillageName}</span>
                          <button
                            type="button"
                            className="btn-remove-item"
                            onClick={() => removeSelectedVillage(v.cityVillageCode)}
                            disabled={isLoading}
                          >
                            <FiX />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={() => setStep(2)}
              disabled={isLoading}
            >
              ← Back
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={isLoading || selectedVillages.length === 0}
            >
              {isLoading ? 'Creating...' : 'Complete Registration'}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

export default AddBusRoute;